// externals
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';

// libraries
import { Box } from '@interstate/components/Box';
import { Grid } from '@interstate/components/Grid';
import { BreakPoint } from '@makemydeal/dr-activities-common';
import {
    ComplianceBannerAlert,
    DataLoadingToastForManuallyAppliedTemplate,
    PushToDMSSuccessBanner,
    AioErrorAlert,
    CviCostMismatchAlert,
    VehicleChangeRetentionBanner
} from '@makemydeal/dr-dash-components';

// components
import { DealDashboardContainer } from './DeskingActivity.styles';

// selectors

// utils
import { LenderChangeAlert } from './LenderChangeAlert';
import { DeskingActivityDeal } from './deskingActivity/DeskingActivityDeal';
import RollToChangeAlert from './RollToChangeAlert';
import { BreakdownActionButton } from './BreakdownActionButton/BreakdownActionButton';
import Breakdown from './baseDealActivity/baseDealContainer/Breakdown/Breakdown';
import { scopedStateSelectors } from '@makemydeal/shared-scoped-store';

const DeskingActivityInterstate = () => {
    const isTabletView = useMediaQuery({ query: `(max-width: ${BreakPoint.MEDIUM})` });

    const primaryScopeId = useSelector(scopedStateSelectors.getPrimaryScopeId);

    const renderCompactUIBreakdown = () => {
        if (isTabletView) return null;

        return <Breakdown scopeId={primaryScopeId} isLightMode alwaysVisible />;
    };

    return (
        <Grid container data-testid="activities-desking" gap="1rem" alignItems="flex-start">
            {renderCompactUIBreakdown()}
            <Grid xs>
                <VehicleChangeRetentionBanner />
                <ComplianceBannerAlert />
                <LenderChangeAlert />
                <RollToChangeAlert />
                <PushToDMSSuccessBanner />
                <AioErrorAlert />
                <CviCostMismatchAlert />
                <DataLoadingToastForManuallyAppliedTemplate />
                <DealDashboardContainer data-testid="deal-dashboard-container">
                    <Grid container justifyContent="flex-end" alignItems="baseline">
                        {isTabletView && (
                            <Box mb={2}>
                                <BreakdownActionButton mode="slideout" />
                            </Box>
                        )}
                    </Grid>
                </DealDashboardContainer>
                <DeskingActivityDeal />
            </Grid>
        </Grid>
    );
};

export default DeskingActivityInterstate;
